import { Briefcase, GraduationCap, RotateCcw, School } from 'lucide-react';

const AUDIENCES = [
  {
    title: 'Unfinished high school',
    text: 'Finish the credential on your own schedule.',
    icon: School,
  },
  {
    title: 'Grade 10 / O Level',
    text: 'Use what you already know and fill the gaps.',
    icon: GraduationCap,
  },
  {
    title: 'Study gap',
    text: 'Come back without starting from zero.',
    icon: RotateCcw,
  },
  {
    title: 'College or work',
    text: 'Prepare for the next application.',
    icon: Briefcase,
  },
];

export default function AudienceCards() {
  return (
    <section className="px-5 py-16 md:py-24" aria-labelledby="audience-heading">
      <div className="mx-auto max-w-[1180px]">
        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[#c5a046]">Who it is for</p>
        <h2
          id="audience-heading"
          className="mt-2 max-w-xl text-3xl text-[#0f2137] md:text-5xl"
          style={{ fontFamily: 'Outfit, sans-serif', letterSpacing: '-0.03em' }}
        >
          Built for learners who need a flexible path.
        </h2>
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {AUDIENCES.map((item) => {
            const Icon = item.icon;
            return (
              <article key={item.title} className="rounded-3xl bg-[#1b365d] p-6 text-white">
                <Icon strokeWidth={1.5} aria-hidden="true" />
                <h3 className="mt-8 text-2xl" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-white/75">{item.text}</p>
              </article>
            );
          })}
        </div>
        <p className="mt-5 max-w-xl text-sm text-[#5b6570]">
          Official GED testing rules depend on your country and testing authority.
        </p>
      </div>
    </section>
  );
}
